import React, { useEffect, useRef } from 'react';
import './GradientText.css';

const GradientText = ({ 
  children, 
  className = '', 
  colors = ['#ff6b35', '#ffa726', '#ff8c61', '#ffb74d'],
  animationSpeed = 3,
  as: Component = 'span'
}) => {
  const textRef = useRef(null);

  useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    element.style.setProperty('--gradient-color-1', colors[0]);
    element.style.setProperty('--gradient-color-2', colors[1]);
    element.style.setProperty('--gradient-color-3', colors[2] || colors[0]);
    element.style.setProperty('--gradient-color-4', colors[3] || colors[1]);
    element.style.setProperty('--animation-speed', `${animationSpeed}s`);
  }, [colors, animationSpeed]);

  return (
    <Component 
      ref={textRef}
      className={`gradient-text ${className}`}
    >
      {children}
    </Component>
  );
};

export default GradientText;
